import { all, put, select, take, takeLatest } from 'redux-saga/effects';
import { types as asrTypes } from '../../actions/backendAsr';
import { getAppConfig, types as configTypes } from '../../actions/backendConfig';
import { allSettingReceived } from '../../actions/backendCommon';
import { requestProfileScores } from '../../actions/backendProfile';
import { types as snoozeTypes } from '../../actions/backendSnooze';
import { getAuthTeamId } from '../../selectors/auth';
import { USER_PROFILE_FETCH_SUCCESS } from '../../actions/actionTypes/userProfile';

const putThunk = (action: unknown) => put(action as never);

interface SagaAction {
    type?: string;
    payload?: {
        snoozeFor?: number;
    };
}

export function* onUserProfileFetched(action: SagaAction): Generator<unknown, void, unknown> {
    const { snoozeFor } = action.payload || {};

    if (snoozeFor && snoozeFor > 0) {
        yield put({
            type: snoozeTypes.SET_SNOOZE_TIMER_SUCCESS,
            payload: { snoozeFor }
        });
        return;
    }

    // Triggering getAppConfig -> Get devices list -> start mix request (listener)
    yield putThunk(getAppConfig());

    const teamID = yield select(getAuthTeamId);
    yield putThunk(requestProfileScores(Number(teamID) || 0));
}

function* waitForUserProfileFetched(): Generator<unknown, void, unknown> {
    yield takeLatest(USER_PROFILE_FETCH_SUCCESS, onUserProfileFetched);
}

function* waitForSettings(): Generator<unknown, void, unknown> {
    yield all([take(configTypes.GET_APP_CONFIG_SUCCESS), take(asrTypes.GET_USER_ASR_CONFIG_SUCCESS)]);

    yield put(allSettingReceived());
}

export default [waitForUserProfileFetched(), waitForSettings()];
